import React, { useEffect, useState } from 'react';
import { translate } from '../../services/translate';
import { useAuth } from '../../context/Auth';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../FormDropDownPicker';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { PlateType } from '../../services/central-api/license-plate-recognition';

type Props = {
    zIndex: number;
    disabled?: boolean;
    required?: boolean;
    includeAll?: boolean;
    includeDebris?: boolean;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value: PlateType | 'all';
    setValue: (value: PlateType | 'all') => void;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function PlateTypeDropdown({ form, fieldName, value, setValue, zIndex, disabled, required, includeAll, includeDebris = true }: Props) {
    const [items, setItems] = useState<{ label: string; value: string; }[]>([]);
    const { user } = useAuth();

    function getPlateType() {
        try {
            const plateTypes: string[] = [];
            if (includeAll && (
                user?.isAdmin
                || user?.permissions.lpr_module_access
                || user?.permissions.lpr_edit_illegal_debris
                || user?.permissions.lpr_edit_denylist)
            ) {
                plateTypes.push('all');
            }

            if (includeDebris && (user?.isAdmin || user?.permissions.lpr_module_access || user?.permissions.lpr_edit_illegal_debris)) {
                plateTypes.push('illegal_debris');
            }
            if (user?.isAdmin || user?.permissions.lpr_module_access || user?.permissions.lpr_edit_denylist) {
                plateTypes.push('deny_list');
            }

            const items = plateTypes.map((plateType) => {
                return {
                    value: plateType,
                    label: translate(plateType)
                };
            });
            setItems(items);
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        if (user) {
            getPlateType();
        }
    }, [user]);

    if (form && fieldName) {
        return <FormDropDownPicker
            label={translate('type')}
            items={items}
            zIndex={zIndex}
            disabled={disabled}
            required={required}
            fieldName={fieldName}
            form={form}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return (
            <FilterDropdown
                label={translate('type')}
                items={items}
                setValue={(val) => {
                    const resolved = typeof val === 'function' ? val(value) : val;
                    setValue(resolved);
                }}
                value={value}
                zIndex={zIndex}
                disabled={disabled}
                required={required}
            />
        );
    }
}

export default PlateTypeDropdown;
